import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { AlertBody } from '@components/Alerts/AlertBody/AlertBody';
import { AlertDisplayField } from '@components/Alerts/AlertDisplayField/AlertDisplayField';
import {
	CommonCancellationAlertBodyProps
} from '@components/Alerts/NotificationAlert/CommonCancellationAlertBody/CommonCancellationAlertBodyProps';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { useSelector } from 'react-redux';
import { CaseDetailsInfoSelector } from '@store/selectors/CaseDetailsSelector';
import { RootState } from '@interfaces/rootState';
import { SurgeryRequestGet } from '@interfaces/SurgeryRequest/SurgeryRequestGet';
import { utcToLocalTime } from '@utilities/dateUtilities';

const useStyles = makeStyles((theme) => createStyles({
	cancellationReason: {
		display: 'flex',
		flex: '0 0 auto',
		flexDirection: 'row',
		marginRight: theme.spacing(2),
	},
	cancellationSection: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: theme.spacing(1),
	},
	detailsLabel: {
		fontWeight: 600,
	},
	detailsText: {
		fontStyle: 'italic',
		fontWeight: '400',
	},
	rescheduleIntent: {
		display: 'flex',
		flex: '0 0 50%',
		flexDirection: 'row',
		marginLeft: 'auto',
	},
	root: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: theme.spacing(0),
		width: '100%',
	},
}));

export const CommonCancellationAlertBody: React.FC<CommonCancellationAlertBodyProps> = ({
	message,
	links,
}) => {
	const classes = useStyles();
	const { wCancellationReasonOptions } = useSsmUiFlags();

	const { cancellation } = useSelector(
		CaseDetailsInfoSelector as (state: RootState) => SurgeryRequestGet
	);

	const convertedDate = React.useMemo(() =>
		utcToLocalTime(cancellation.dateUpdated), [cancellation.dateUpdated]);

	return (
		<AlertBody
			alertUser={`${cancellation.userUpdated.firstName} ${cancellation.userUpdated.lastName}`}
			alertTime={convertedDate}
			alertMessage={message}
			links={links}
			body={
				<Box className={classes.root}>
					{wCancellationReasonOptions.length ? (
						<Box className={classes.cancellationSection}>
							<AlertDisplayField
								className={classes.cancellationReason}
								label="Cancel reason:"
							>
								{cancellation.ssmCancellationReason || '--'}
							</AlertDisplayField>
							<AlertDisplayField
								className={classes.rescheduleIntent}
								label="Planning to reschedule:"
							>
								{cancellation.intendToReschedule === null || cancellation.intendToReschedule === undefined
									? '--'
									: cancellation.intendToReschedule ? 'Yes' : 'No'}
							</AlertDisplayField>
						</Box>
					) : null}
					<Box>
						<Typography
							className={classes.detailsLabel}
							component="label"
							variant="body2"
						>
							Details
						</Typography>
						<Typography className={classes.detailsText}>
							{cancellation.message || '--'}
						</Typography>
					</Box>
				</Box>
			}
		/>
	);
};
